import {combineReducers} from "redux"
import {createPivotTableReducer} from "reducers/pivotTable"
import approvalDrawer from "reducers/quotingContext/selected/approvalDrawer/approvalDrawer"
import types from "actions/types"

export const quotingContextQuoteApprovalsPivotTableKey = 'quotingContext.selected.approvals.pivotTable'

const customerLink = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_LOAD_APPROVAL_CUSTOMER_LINK_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  approvalDrawer,
  customerLink,
  pivotTable: createPivotTableReducer({
    key: quotingContextQuoteApprovalsPivotTableKey,
    defaultSortColumn: 'createdDate',
  }),
})
